import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import Historia from '../components/comuna/Historia';

const ComunaContainer = () => {

  return (
    <div className='MainMunicipio'>
      <Historia />
    </div>
  );
};
export default ComunaContainer;
